import { createApp } from 'vue'
import App from './App.vue'

import router from './router'

import { createPinia } from 'pinia'

import Chessboard from './js/henry-chessboard.js'
import "@/css/henry-chessboardjs.css"

// https://pinia.vuejs.org/core-concepts/outside-component-usage.html#single-page-applications

import HoneybadgerVue from '@honeybadger-io/vue'

const config = {
  apiKey: 'hbp_1aAFp0KJWJ8WPBXm6cNwoVCePOEKbf0p4VHr',
  environment: 'production'
}

const pinia = createPinia()
const app = createApp(App)

// comment out in development
if (process.env.NODE_ENV === 'production')
  app.use(HoneybadgerVue, config)

app.use(router)
app.use(pinia)
app.mount('#app')

// createApp(App).use(createPinia()).use(router).mount('#app')
